/* Jumpbar „femieko MEDICAL”: se lipește sub antetul site-ului și marchează secțiunea curentă. */
(function () {
  'use strict';
  var scope = document.querySelector('.fe-med-scope');
  if (!scope) return;
  var bar = scope.querySelector('header');
  var siteHeader = document.querySelector('.shopify-section-group-header-group header.header, .shopify-section-group-header-group header');
  var siteSection = siteHeader && siteHeader.closest('.shopify-section');

  function setTop() {
    var h = 0;
    if (siteSection) {
      var cs = getComputedStyle(siteSection);
      if (cs.position === 'sticky' || cs.position === 'fixed') h = siteSection.getBoundingClientRect().height;
      else if (siteHeader) {
        var hs = getComputedStyle(siteHeader);
        if (hs.position === 'sticky' || hs.position === 'fixed') h = siteHeader.getBoundingClientRect().height;
      }
    }
    scope.style.setProperty('--fe-med-top', Math.round(h) + 'px');
  }
  setTop();
  window.addEventListener('resize', setTop, { passive: true });
  window.addEventListener('load', setTop);
  if (window.ResizeObserver && siteSection) new ResizeObserver(setTop).observe(siteSection);

  // secțiunea curentă
  if (!bar) return;
  var links = Array.prototype.slice.call(bar.querySelectorAll('nav a[href^="#"]'));
  var map = [];
  links.forEach(function (a) {
    var id = a.getAttribute('href').slice(1);
    var t = id && document.getElementById(id);
    if (t) map.push({ a: a, t: t });
  });
  if (!map.length || !('IntersectionObserver' in window)) return;
  var current = null;
  function mark(a) {
    if (current === a) return;
    links.forEach(function (l) { l.classList.remove('is-current'); l.removeAttribute('aria-current'); });
    if (a) { a.classList.add('is-current'); a.setAttribute('aria-current', 'true'); }
    current = a;
  }
  var io = new IntersectionObserver(function () {
    var best = null, bestTop = -Infinity, line = (parseInt(getComputedStyle(scope).getPropertyValue('--fe-med-top'), 10) || 0) + 140;
    map.forEach(function (m) {
      var r = m.t.getBoundingClientRect();
      if (r.top <= line && r.bottom > line && r.top > bestTop) { best = m.a; bestTop = r.top; }
    });
    mark(best);
  }, { rootMargin: '0px 0px 0px 0px', threshold: [0, 0.01, 0.25, 0.5, 1] });
  map.forEach(function (m) { io.observe(m.t); });
  window.addEventListener('scroll', function () { io.takeRecords(); }, { passive: true });
})();
